import { call, put, select } from 'redux-saga/effects';
import {
  fetchMeRequest,
  updateCurrentUserPreferencesFailure,
  updateCurrentUserPreferencesSuccess,
} from '../actions';
import { updateCurrentUserPreferences } from '../api';
import { UpdateCurrentUserPreferencesRequestAction } from '../types';
import { getAuthUser } from '../selectors';
import { User } from '../models';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* updateCurrentUserPreferencesSaga(
  action: UpdateCurrentUserPreferencesRequestAction
) {
  const { preferences } = action.payload;
  const currentUser: User = yield select(getAuthUser);
  const preferenceId = currentUser?.prefDetails?.[0] || '';

  try {
    yield call(updateCurrentUserPreferences, preferenceId, preferences);
    if (currentUser.prefDetails && currentUser.prefDetails.length > 0) {
      yield put(updateCurrentUserPreferencesSuccess(preferences));
    } else {
      yield put(fetchMeRequest());
    }
  } catch (e) {
    yield put(updateCurrentUserPreferencesFailure());
  }
}
